import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
export function header() {
    document.addEventListener('DOMContentLoaded', function () {
        gsap.config({ nullTargetWarn: false })

        // change-colorアニメーション
        window.addEventListener('scroll', function () {
            var header = document.querySelector('.js-header');
            if (document.querySelector('.js-mv').offsetHeight < window.scrollY) {
                header.classList.add('change-color');
                updateHeaderLogo(true);
            } else {
                header.classList.remove('change-color');
                updateHeaderLogo(false);
            }
        });

        function updateHeaderLogo(isChanged) {
            var logo = document.querySelector('.p-header__logo-img img');
            if (logo) {
                var newSrc = isChanged ? logo.getAttribute('data-alt-src') : logo.src.replace('logo-black.svg', 'logo-white.svg');
                logo.src = newSrc;
            }
        }

        document.querySelectorAll('.js-hamburger').forEach(function (hamburger) {
            hamburger.addEventListener('click', function () {
                this.classList.toggle('is-open');
                const drawer = document.querySelector('.js-drawer');
                if (drawer.classList.contains('is-open')) {
                    closeDrawer();
                } else {
                    openDrawer();
                }
            });
        });

        document.querySelectorAll('.p-header__nav-item a').forEach(function (link) {
            link.addEventListener('click', function () {
                if (document.querySelector('.js-hamburger').classList.contains('is-open')) {
                    closeDrawer();
                }
            });
        });

        document.querySelectorAll('.js-drawer a[href]').forEach(function (link) {
            link.addEventListener('click', function () {
                closeDrawer();
            });
        });

        window.addEventListener('resize', function () {
            if (window.matchMedia('(min-width: 768px)').matches) {
                closeDrawer();
            }
        });
    });

    function openDrawer() {
        const drawer = document.querySelector('.js-drawer');
        const header = document.querySelector('.js-header');
        drawer.classList.add('is-open');
        header.classList.add('is-drawer-open'); // ヘッダーにクラスを追加
        document.body.classList.add('body-no-scroll');
        updateDrawerLogo(true); // ドロワーメニューが開く時、ロゴを白色に変更

        // ナビゲーションリストの各項目を選択
        const items = document.querySelectorAll('.js-nav-list');
        // 各項目に遅延を設定してアニメーションを適用
        items.forEach((item, index) => {
            // すべての項目に150ms * index の遅延を設定
            setTimeout(() => {
                item.classList.add('is-open');
            }, 150 * index);
        });
    }


    function closeDrawer() {
        setTimeout(() => {
            const drawer = document.querySelector('.js-drawer');
            const header = document.querySelector('.js-header');
            const hamburger = document.querySelector('.js-hamburger');
            drawer.classList.remove('is-open');
            header.classList.remove('is-drawer-open'); // ヘッダーからクラスを削除
            hamburger.classList.remove('is-open');
            document.body.classList.remove('body-no-scroll');

            updateDrawerLogo(false); // ドロワーメニューが閉じた時、ロゴの状態を更新

            // アニメーションを削除
            const items = document.querySelectorAll('.js-nav-list');
            items.forEach(item => item.classList.remove('is-open'));
        }, 100); // 0.1秒遅延後に実行
    }
    function updateDrawerLogo(isDrawerOpen) {
        const logo = document.querySelector('.p-header__logo-img img');
        if (isDrawerOpen) {
            logo.src = "https://addfuture.saporuto.com/add2024/wp-content/themes/addfuture/assets/images/common/logo-white.svg";
        } else {
            const header = document.querySelector('.js-header');
            if (header.classList.contains('change-color')) {
                logo.src = "https://addfuture.saporuto.com/add2024/wp-content/themes/addfuture/assets/images/common/logo-black.svg";
            } else {
                logo.src = "https://addfuture.saporuto.com/add2024/wp-content/themes/addfuture/assets/images/common/logo-white.svg";
            }
        }
    }
}